(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationBaggageServiceComponentDetails',
	};

	var $form;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		$('#reservationbaggageservicecomponentdetails-set_final_payment_date').on('change', function change(e) {
			if ($(this).prop('checked') === true) {
				$form.find('.final-payment-date').removeClass('hidden');
				$form.find('.soft-payment-date').removeClass('hidden');
			} else {
				$form.find('.final-payment-date').addClass('hidden');
				$form.find('.soft-payment-date').addClass('hidden');
			}
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#reservationbaggageservicecomponentdetails-final_payment_date').on('dp.change', function dateChange(event) {
			var $final_payment_date     = $(this),
				$soft_payment_date      = $('#reservationbaggageservicecomponentdetails-soft_payment_date'),
				soft_payment_date       = null,
				formatted_soft_date     = null,
				new_soft_payment_date   = null,
				formatted_new_soft_date = null;

			if ($final_payment_date.val() === $final_payment_date.data('current-value')) {
				return;
			}

			$final_payment_date.data('current-value', $final_payment_date.val());

			if (event.date) {
				soft_payment_date = $soft_payment_date.data('DateTimePicker');

				if (soft_payment_date && soft_payment_date.date()) {
					formatted_soft_date = soft_payment_date.date().format("M/D/YYYY");
				} else {
					formatted_soft_date = "(No date entered)";
				}

				new_soft_payment_date = event.date;
				new_soft_payment_date.subtract($soft_payment_date.data('soft-date-days'), 'days');
				formatted_new_soft_date = new_soft_payment_date.format('M/D/YYYY');

				Adzuki.CustomConfirm({
					title  : 'Change soft date?',
					content: 'Would you like to change the Final Soft Payment Date for this component from ' + formatted_soft_date + ' to ' + formatted_new_soft_date + ' (' + parseInt($soft_payment_date.data('soft-date-days')) + ' days before the Final Payment Date)? Click \'Yes\' to update the Final Payment Soft Date or \'No\' to keep the current Final Payment Soft Date.',
					confirm: function confirm() {
						soft_payment_date.date(new_soft_payment_date);
						// return true;
					}
				});
			}
		});

		$('#reservationbaggageservicecomponentdetails-service_type').change(function serviceTypeChanges() {
			if ($(this).val() === 'roundtrip') {
				$('.return-header').removeClass('hidden');
				$('.return-fields').removeClass('hidden');
			} else {
				$('.return-header').addClass('hidden');
				$('.return-fields').addClass('hidden');
			}
		});

		// departure
		$('#reservationbaggageservicecomponentdetails-departure_pick_up_datetime-date').on('dp.change', function dropoffChanged(event) {
			var startDate = event.date,
				endDate   = $('#reservationbaggageservicecomponentdetails-departure_drop_off_datetime-date').data('DateTimePicker');

			if (startDate && endDate) {
				endDate.date(startDate.add(0, 'days'));
			}
		});

		$('#reservationbaggageservicecomponentdetails-departure_pick_up_datetime-time').on('dp.change', function dropoffChanged(event) {
			var startTime = event.date,
				endTime   = $('#reservationbaggageservicecomponentdetails-departure_drop_off_datetime-time').data('DateTimePicker');

			if (startTime && endTime) {
				endTime.date(startTime);
			}
		});

		// return
		$('#reservationbaggageservicecomponentdetails-return_pick_up_datetime-date').on('dp.change', function dropoffChanged(event) {
			var startDate = event.date,
				endDate   = $('#reservationbaggageservicecomponentdetails-return_drop_off_datetime-date').data('DateTimePicker');

			if (startDate && endDate) {
				endDate.date(startDate.add(0, 'days'));
			}
		});

		$('#reservationbaggageservicecomponentdetails-return_pick_up_datetime-time').on('dp.change', function dropoffChanged(event) {
			var startTime = event.date,
				endTime   = $('#reservationbaggageservicecomponentdetails-return_drop_off_datetime-time').data('DateTimePicker');

			if (startTime && endTime) {
				endTime.date(startTime);
			}
		});
	};

}(jQuery, window.Adzuki || {}));
